// extracted by mini-css-extract-plugin
export var aiStarIcon = "_b4-4";
export var closeButton = "_b4-6";
export var dismissButton = "_b4-3";
export var editImageWithAiContainer = "_b4-8";
export var imageUploadWrapper = "_b4-7";
export var misspelledWord = "_b4-5";
export var spellCheckContainer = "_b4-2";
export var spin = "_b4-1";
export var spinning = "_b4-0";